import {
	type HmmRegion,
	type RiskValueOnMap,
	HmmControllerApiFactory,
	HmmTimeSeriesControllerApiFactory,
} from "@eu.mdotm.api/sphere";
import { getApiGen } from "$root/api/factory";
import { repositoryHelperFactory } from "$root/api/repository";
import { eventBus } from "$root/event-bus";
import { axiosExtract } from "$root/third-party-integrations/axios";
import { minutes, seconds } from "$root/utils";
import debounce from "debounce";

const { newQuery, invalidate } = repositoryHelperFactory("hmm", {
	repositoryQueryOverrides: {
		cacheTime: minutes(10),
		staleTime: minutes(10),
	},
});

const hmmTimeSeriesApi = () => getApiGen(HmmTimeSeriesControllerApiFactory);
const hmmApi = () => getApiGen(HmmControllerApiFactory);

export const hmmRepository = {
	globalRiskMapDatesIsoFormat: newQuery("retrieveGlobalRiskMapDatesIsoFormat", (valueOnMap: RiskValueOnMap) =>
		axiosExtract(hmmTimeSeriesApi().retrieveGlobalRiskMapDatesIsoFormat(valueOnMap)),
	),

	globalRiskMapIsoFormat: newQuery(
		"retrieveGlobalRiskMapIsoFormat",
		(valueOnMap: RiskValueOnMap, opts: { from: string; to: string }) =>
			axiosExtract(hmmTimeSeriesApi().retrieveGlobalRiskMapIsoFormat(valueOnMap, opts.from, opts.to)),
	),

	scenarioDescription: newQuery("retrieveScenarioDescription", (region: HmmRegion) =>
		axiosExtract(hmmApi().retrieveScenarioDescription(region)),
	),

	sectorsWithRegime: newQuery("retrieveSectorsWithRegime", (region: HmmRegion) =>
		axiosExtract(hmmApi().retrieveSectorsWithRegime(region)),
	),

	evolutionOfRegime: newQuery("retrieveEvolutionOfRegime", (region: HmmRegion) =>
		axiosExtract(hmmApi().retrieveEvolutionOfRegime(region)),
	),

	globalEvolutionOfRegime: newQuery("retrieveGlobalEvolutionOfRegime", () =>
		axiosExtract(hmmTimeSeriesApi().retrieveEvolutionOfRegime1()),
	),

	globalProbabilityDistance: newQuery("retrieveGlobalProbabilityDistance", () =>
		axiosExtract(hmmTimeSeriesApi().retrieveOverviewTimeSeries2()),
	),

	marketView: newQuery("retrieveMarketView", (region: HmmRegion) => axiosExtract(hmmApi().retrieveMarketView(region))),

	pastMarketRegime: newQuery("retrievePastMarketRegime", (region: HmmRegion) =>
		axiosExtract(hmmApi().retrievePastMarketRegime(region)),
	),

	sectorsBreakdown: newQuery("retrieveSectorsBreakDown", (region: HmmRegion) =>
		axiosExtract(hmmApi().retrieveSectorsBreakDown(region)),
	),
	regimeCounter: newQuery("retrieveRegimeCounter", (region: HmmRegion) =>
		axiosExtract(hmmApi().retrieveRegimeCounter(region)),
	),

	regimesTransitionMatrices: newQuery(
		"retrieveRegimesTransitionMatrices",
		(region: HmmRegion, opts: { days: string /* idk why the API wants a string, but whatever */ }) =>
			axiosExtract(hmmApi().retrieveRegimesTransitionMatrices(region, opts.days)),
	),
} as const;

eventBus.addListener(
	"market-update",
	debounce(() => {
		invalidate();
	}, seconds(2)),
);
